import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, ActivationEnd } from '@angular/router';
import { AclService } from '../../services/acl.service';

@Component({
  selector: 'third-party-embed',
  templateUrl: './third-party-embed.component.html',
  styleUrls: ['./third-party-embed.component.css'],
  standalone: false
})
export class ThirdPartyEmbedComponent implements OnInit {
  @Input() content: TemplateRef<any>;
  @Input() minRole: string;

  public display: boolean = null;
  public context: 'client' | null;
  public clientCode: string;
  public currentUserName: string;

  constructor(
    private aclService: AclService,
    public authService: AuthService,
    public router: Router
  ) {
    // NOTE: this is how the current apollo context is found
    // if url has a client_code, user is in client context
    // as more context types appear, add rules for them,
    // or find a more tenable solution
    router.events.subscribe(val => {
      if (val instanceof ActivationEnd) {
        if (val.snapshot.paramMap.has('client_code')) {
          this.clientCode = val.snapshot.paramMap.get('client_code');
          this.context = 'client';
        } else if (!val.snapshot.paramMap.has('client_code')) {
          this.clientCode = null;
          this.context = null;
        }
      }
    });
  }

  ngOnInit() {
    this.currentUserName = this.authService.getCurrentUserName();

    // NOTE: add ACL join logic here if necessary
    this.aclService
      .HasMinimumRoleByName(this.authService.getCurrentUserId(), this.minRole)
      .subscribe(
        hasRole => {
          this.display = hasRole;
        },
        err => {
          this.display = false;
        }
      );
  }
}
